import React from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import {useNavigate} from 'react-router-dom';

const BackUp = () => {
  const navigate = useNavigate();
  return (
    <div className="flex w-full h-full flex-col justify-between">
      <CustomHeader
        title={'پشتیبانی'}
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
      />
      <div className="flex w-full flex-col justify-between h-full">
        <div className="flex flex-col px-3">
          <div
            className="d-flex w-full justify-between items-center px-2 no-underline h-[56px] border-b border-gray-200 text-inherit"
            onClick={() => {
              navigate('/faq');
            }}
          >
            <div className="text-md text-gray-900 flex items-center font-Regular">
              <SpanIcon className="" />
              <div>سوالات پرتکرار</div>
            </div>
            <button>
              <SpanIcon className="icon-nameArrow---Left-2 text-xxl" />
            </button>
          </div>
          <div className="d-flex w-full justify-between items-center px-2 no-underline h-[56px] border-b border-gray-200 text-inherit">
            <a
              href="tel:02166402031"
              className="text-md text-gray-900 flex items-center font-Regular no-underline	"
            >
              <SpanIcon className="" />
              <div>تماس با پشتیبانی</div>
            </a>
            <a
              href="tel:02166402031"
              className="no-underline text-md text-gray-900 flex items-center font-Regular"
            >
              <SpanIcon className="icon-nameArrow---Left-2 text-xxl" />
            </a>
          </div>
        </div>
        <div className="flex w-full justify-center my-4">
          <img
            width={233}
            height={182}
            src="https://my-account.s3.ir-thr-at1.arvanstorage.ir/questions.svg"
            alt="questions"
          />
        </div>
      </div>{' '}
      <MainFooter />
    </div>
  );
};

export default BackUp;
